import { graphql } from '@teachino/shared-infrastructure';

export const createCourseMaterialMutation = graphql(`
  mutation CreateCourseMaterial(
    $courseFolderId: String
    $courseId: String!
    $name: String!
    $contentHtml: String
    $icon: String
    $initialIpiRequestId: String
    $newEditor: Boolean!
  ) {
    createCourseMaterial(
      createCourseMaterialInput: {
        courseFolderId: $courseFolderId
        courseId: $courseId
        position: -1
        name: $name
        icon: $icon
        initialIpiRequestId: $initialIpiRequestId
        contentHtml: { html: $contentHtml }
        newEditor: $newEditor
      }
    ) {
      __typename
      courseMaterial {
        id
        material {
          __typename
          id
        }
      }
    }
  }
`);
